module.exports = __webpack_public_path__ + "img/4FE34F_2BB02B_3CD03C_1C861C-256px.b8e40c14.png";